import { render, staticRenderFns } from "./enviosiisa.vue?vue&type=template&id=72611148"
import script from "./enviosiisa.vue?vue&type=script&lang=js"
export * from "./enviosiisa.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports